export const yesOrNot = [
  { codigo: 'si', etiqueta: 'Si' },
  { codigo: 'no', etiqueta: 'No' },
  { codigo: 'no_especificado', etiqueta: 'No especifica' },
];
